import { format } from 'date-fns';

import i18n from 'locales/i18n';

import { TTReportRes } from '@apis/orval/model';

import round, { roundFloat } from '@utils/round';

import { KeyMetricsTtProps } from './KeyMetrics';

export class KeyMetricsTtAdapter {
	value: TTReportRes;

	constructor(obj: TTReportRes) {
		this.value = obj;
	}

	get averageViews() {
		const averageViewsValue = this.value?.core_metrics?.avg_view;
		return i18n?.t('unit.times', {
			number: averageViewsValue?.toString() ? round(averageViewsValue, 'down') : '-',
		});
	}

	get averageLikes() {
		const averageLikesValue = this.value?.core_metrics?.avg_like;
		return i18n?.t('unit.counts', {
			number: averageLikesValue?.toString() ? round(averageLikesValue, 'down') : '-',
		});
	}

	get averageComments() {
		const averageCommentsValue = this.value?.core_metrics?.avg_comment;
		return i18n?.t('unit.counts', {
			number: averageCommentsValue?.toString()
				? round(averageCommentsValue, 'down')
				: '-',
		});
	}

	get averageShares() {
		const realFollowersValue = this.value?.core_metrics?.avg_share;
		return i18n?.t('unit.times', {
			number: realFollowersValue?.toString() ? round(realFollowersValue, 'down') : '-',
		});
	}

	get averageSaves() {
		const averageReachValue = this.value?.core_metrics?.avg_save;
		return i18n?.t('unit.times', {
			number: averageReachValue?.toString() ? round(averageReachValue, 'down') : '-',
		});
	}

	get engagementRate() {
		const engagementRateValue = this.value?.core_metrics?.real_engagement;
		return engagementRateValue?.toString()
			? `${roundFloat(engagementRateValue, 'down', 2)} %`
			: '- %';
	}

	get updatedAt() {
		const updatedTime = this.value?.updated_time;

		return updatedTime ? format(new Date(updatedTime), 'yyyy. MM. dd') : undefined;
	}

	adapt(): { updatedAt?: string; props: KeyMetricsTtProps } {
		return {
			updatedAt: this.updatedAt,
			props: {
				averageViews: this.averageViews,
				averageLikes: this.averageLikes,
				averageComments: this.averageComments,
				averageShares: this.averageShares,
				averageSaves: this.averageSaves,
				engagementRate: this.engagementRate,
			},
		};
	}
}
